<!--
 * @Description: 传入record数据，通过判断record.type，来渲染对应的组件
 * @Author: xxx
 * @Date: 2025-10-28 10:41:48
 * @LastEditors: xxx
 * @LastEditTime: 2025-10-28
 -->
<template>
  <div class="tools-check" v-if="selectItem.key === record.key && isShowEdit()">
    <div class="item" id="batch"><img src="@/assets/icon/kform/add.png" alt="">
      <a-popconfirm cancelText="取消" okText="确认" placement="right"
        :getPopupContainer="getPopupContainer" @cancel="handleCancel" @confirm="handleBatchAdd(1)">
        <template slot="title">
          <p>批量新增选项</p>
          <div style="max-height: 80vh;overflow-y: auto;overflow-x: hidden;width: 100%;">
            <CsimChangeOption ref="csimChangeOptionRef" :selectForm="selectForm" v-show="!options.dynamic"
              v-model="options.options" :isEdit="true" :isBatch="true" @refreshOptions="refreshOptions" />
          </div>
        </template>
        <div @click="handleBAdd(1)">批量新增选项</div>
      </a-popconfirm>
    </div>
    <div class="item"><img src="@/assets/icon/kform/edit.png" alt="">
      <a-popconfirm placement="bottom" :getPopupContainer="getPopupContainer"
        @cancel="handleCancel" @confirm="handleBatchAdd(2)">
        <template slot="title">
          <p>选项编辑</p>
          <div style="width: 100%;">
            <CsimChangeOption ref="csimChangeOptionRef" :type="record.type" :selectForm="selectForm" :isEdit="true"
              v-show="!options.dynamic" @refreshOptions="refreshOptions" v-model="options.options" />
          </div>
        </template>
        <div @click="handleBAdd(2)">编辑选项</div>
      </a-popconfirm>
    </div>
  </div>
</template>
<script>
/*
 * author kcz
 * date 2019-11-20
 */
import CsimChangeOption from "@views/tempconfig/formDesign/csim/CsimChangeOption.vue";
export default {
  name: "formOption",
  props: {
    // 表单数组
    record: {
      type: Object,
      required: true
    },
    // form-item 宽度配置
    // formConfig: {
    //   type: Object,
    //   required: true
    // },
    config: {
      type: Object,
      default: () => ({})
    },
    dynamicData: {
      type: Object,
      default: () => ({})
    },
    disabled: {
      type: Boolean,
      default: false
    },
    selectItem: {
      type: Object,
      default: () => ({})
    },
    selectForm: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      isVisible: false, // 弹框显隐状态
      isVisible2: false, // 弹框显隐状态
      scrollHandler: null, // 滚动事件处理函数
      scrollContainer: null // 滚动容器
    }
  },
  components: {
    CsimChangeOption
  },
  computed: {
    options() {
      return this.selectItem.options || {};
    }
  },
  mounted() {
  },
  methods: {
    refreshOptions(value) {
      if (value) {
        this.isVisible = false
        this.isVisible2 = false
        this.$emit('refreshOptions')
      }
    },
    handleBatchAdd(type) {
      if (type === 1) {
        this.$refs.csimChangeOptionRef.handleBatchAdd()
      } else {
        this.$refs.csimChangeOptionRef.handleSaveOptions()
      }
    },
    handleBAdd(type) {
      if (this.type === 1) {
        this.isVisible = true
      } else {
        this.isVisible2 = true
      }
      this.$nextTick(() => {
        if (type === 1) {
          this.$refs.csimChangeOptionRef && this.$refs.csimChangeOptionRef.handleLoadExisting()
        } else {
          this.$refs.csimChangeOptionRef && this.$refs.csimChangeOptionRef.handleLoadOptions()
        }
      })
    },
    isShowEdit() {
      return ['radio', 'checkbox'].includes(this.record.type)
    },
    // 获取弹出框容器（根据实际场景调整选择器）
    getPopupContainer(el, dialogcontext) {
      if (el) {
        return document.getElementsByClassName("draggable-box")[0].children[0]
      } else {
        return document.getElementsByClassName("draggable-box")[0].children[0]
      }
    },
    // 监听气泡显隐，绑定/解绑滚动事件
    handleCancel() {
      this.isVisible = false
      this.isVisible2 = false
    }
  },
  beforeDestroy() {
  },
  created() {
    let recordType = this.record.type;
    if (recordType === 'selectCard') {
      recordType = 'radio'
    }
  }
}
</script>
<style lang="less" scoped>
.tools-check {
  display: flex;
  gap: 20px;
  // margin-top: 10px;
  cursor: pointer;
  position: relative;
  z-index: 999;
  margin: 0 20px 10px 20px;
  .item {
    display: flex;
    align-items: center;
    gap: 5px;
    font-size: 14px;
    color: #007aff;
    position: relative;
  }

  img {
    width: 16px;
    height: 16px;
  }
}
</style>
